module.exports = __webpack_public_path__ + "static/gestured-2.4ef5c8a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gestured-2.svg
// module id = 444
// module chunks = 35783957827783 172322841747965